/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $VacationListResponse = {
    type: 'array',
    contains: {
        type: 'Vacation',
    },
};